import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { space } from 'styled-system';
import styled from '../../styles/styled';
import { Box } from '..';
export const Avatar = ({ src, displayName = 'User', backgroundColor, color, size = 'small', ...otherProps }) => {
    const [missingImage, setMissingImage] = useState(!src);
    const imageUrl = src && src.length > 0;
    const noImage = !imageUrl || missingImage;
    return (_jsx(AvatarContainer, { ...otherProps, size: size, backgroundColor: noImage ? backgroundColor : 'transparent', children: _jsxs(Box, { position: "relative", children: [_jsx(AvatarImage, { ...otherProps, size: size, onLoad: () => setMissingImage(false), onError: () => setMissingImage(true), src: src, alt: `${displayName}'s Avatar`, style: {
                        visibility: noImage ? 'hidden' : 'visible',
                    }, "data-clarity-mask": "true" }), _jsx(AvatarMonogram, { color: color ?? '', size: size, ...otherProps, style: { visibility: noImage ? 'visible' : 'hidden' }, children: displayName?.charAt(0) })] }) }));
};
Avatar.displayName = 'Avatar';
const AvatarImage = styled.img(props => {
    const size = props.theme.avatarSizes[props.size];
    return {
        transition: 'opacity 0.2s, width 400ms linear, height 400ms linear, border-radius 400ms linear',
        position: 'absolute',
        transform: 'translate(-50%,-50%)',
        width: size + 1,
        height: size + 1,
        borderRadius: Math.ceil(size * 0.5),
        objectFit: 'cover',
    };
});
export const AvatarContainer = styled.div(props => {
    const size = props.theme.avatarSizes[props.size];
    return {
        width: size,
        height: size,
        borderRadius: Math.ceil(size * 0.5),
        backgroundColor: props.backgroundColor ?? props.theme.colors.azure,
        display: 'flex',
        justifyContent: 'center',
        transition: 'all 400ms linear',
        alignItems: 'center',
        overflow: 'hidden',
        flexShrink: 0,
    };
}, space);
const AvatarMonogram = styled.div(({ color, size, theme }) => ({
    position: 'absolute',
    transform: 'translate(-50%,-50%)',
    color: color ? color : theme.colors.white,
    textTransform: 'uppercase',
    fontFamily: theme.text.headingFontFamily,
    fontSize: Math.floor(theme.avatarSizes[size] * 0.45),
    transition: 'all 400ms linear',
    userSelect: 'none',
}));
//# sourceMappingURL=avatar.js.map